<template>
  <div variant="custom" v-bind="$attrs">
    <slot />
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "dtpCardSection",
  inheritAttrs: false,
});
</script>
